module.exports = __webpack_public_path__ + "static/media/greater_london.6a85285a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/greater_london.jpg
// module id = 107
// module chunks = 0